import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeePayrollProcess.css';
import { useNavigate } from 'react-router-dom';
import ExcelJS from "exceljs";
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { fetchMonths, getDistrict, getProjects, getStates } from '../../../services/monthlyAttendanceService';
import { fetchPayrollProcessData } from '../../../services/payrollService';
import { capitalizeFirstLetter } from '../../../utils/validations';

const EmployeePayrollProcess = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(null);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [originalData, setOriginalData] = useState([]);

    const effectRan = useRef();
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
        project: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false);
    const yearInputRef = useRef(null);
    const isFetchDataEnabled = state && month && year;
    // const selectStyles = {
    //     menuPortal: base => ({ ...base, zIndex: 9999 }),
    //     menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
    //     control: provided => ({ ...provided, padding: '1px' }),
    //     valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
    // };
    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label:  capitalizeFirstLetter(item.stateName),
                        name:capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }

    }, []);

    // Fetch months
    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);
    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             const now = new Date();
    //             const currentYear = now.getFullYear();
    //             const currentMonth = now.getMonth() + 1;
    //             const currentDate = now.getDate();
    //             const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

    //             const months = response.data
    //                 .map(item => {
    //                     let daysInMonth;
    //                     if (year === currentYear && item.monthId === currentMonth) {
    //                         daysInMonth = currentDate;
    //                     } else {
    //                         daysInMonth = new Date(year, item.monthId, 0).getDate();
    //                     }
    //                     return {
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                         days: daysInMonth,
    //                     };
    //                 })
    //                 .sort((a, b) => a.value - b.value);

    //             let filteredMonths = months;
    //             if (year) {
    //                 if (year === currentYear) {
    //                     filteredMonths = months.filter(m => {
    //                         if (m.value < currentMonth) return true;
    //                         if (m.value === currentMonth) {
    //                             return currentDate === lastDayOfCurrentMonth;
    //                         }
    //                         return false;
    //                     });
    //                 } else if (year > currentYear) {
    //                     filteredMonths = [];
    //                 } else {
    //                     filteredMonths = months;
    //                 }
    //             }
    //             setMonthOptions(filteredMonths);
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, [year]);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
            setMonth(null);
            setAttendanceData([]);
            setHasFetched(false);
        }
    }, [state]);
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                const data = await getProjects();
                setProjectResponse(data.map(pro => ({
                    value: pro.id,
                    label: pro.projectCode,
                }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchProjects();
        }
        return ()=>{
            effectRan.current=true;
        }

    }, []);
    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'district':
                setDistrict(value);
                setMonth(null);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'month':
                setMonth(value);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        const newYear = date ? date.getFullYear() : null;
        setYear(newYear);
        setMonth(null);
        setAttendanceData([]);
        setHasFetched(false);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(prev => ({ ...prev, ...newErrors }));
        return Object.keys(newErrors).length === 0;
    };

    const handleFetch = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            // build params dynamically
            const params = {
                stateId: state,
                month,
                year,
            };

            if (district) params.districtId = district;
            if (project) params.projectId = project;

            console.log("📦 Params sent to API:", params);

            // Call the service
            const { data, error } = await fetchPayrollProcessData(params);

            // ✅ Handle API-level error message
            if (error) {
                setErrors((prev) => ({ ...prev, general: error }));
                setAttendanceData([]);
                setHasFetched(true);
                return;
            }

            console.log("✅ API Response:", data);
            setAttendanceData(data);
            setOriginalData(data);
            setHasFetched(true);
            setErrors((prev) => ({ ...prev, general: null }));

        } catch (error) {
            console.error("❌ Error fetching payroll process data:", error);

            if (error.response?.status === 409 && error.response?.data?.error) {
                setErrors((prev) => ({
                    ...prev,
                    general: error.response.data.error,
                }));
                setAttendanceData([]);
                setHasFetched(true);
            } else {
                setErrors((prev) => ({
                    ...prev,
                    general:
                        error.response?.data?.message ||
                        "Failed to fetch payroll-process data",
                }));
                setAttendanceData([]);
                setHasFetched(false);
            }
        }
    };

    return (
        <>
            <div className="payroll-process-container">
                <div className="payroll-process-box">
                    <h2 className="payroll-process-heading">Employee Payroll Process</h2>
                    {/* {errors.general && <div className="error-message">{errors.general}</div>} */}
                    <form onSubmit={handleFetch}>
                        <div className="payroll-process-maincontainer">
                            <div className="payroll-process-container-part">
                                <div className={`payroll-process-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                    <Select
                                        name="state"
                                        options={stateOptions}
                                        value={stateOptions.find(opt => opt.value === state) || null}
                                        onChange={option => handleInputChange(option, 'state')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        <span className="required">*</span>State
                                    </label>
                                    {errors.state && <div className="error-message">{errors.state}</div>}
                                </div>
                            </div>
                            <div className="payroll-process-container-part">
                                {/* <div className={`payroll-process-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                    <Select
                                        name="district"
                                        options={districtOptions}
                                        value={districtOptions.find(opt => opt.value === district) || null}
                                        onChange={option => handleInputChange(option, 'district')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                    District
                                    </label>
                                    {errors.district && <div className="error-message">{errors.district}</div>}
                                </div> */}
                            </div>
                        </div>
                        <div className="payroll-process-maincontainer">
                            <div className="payroll-process-container-part">
                                <div className={`payroll-process-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={year ? new Date(year, 0, 1) : null}
                                        onChange={handleYearChange}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                        dateFormat="yyyy"
                                        showYearPicker
                                        placeholderText=""
                                        className="payroll-process-date-picker"
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        ref={yearInputRef}
                                    />
                                    <label>
                                        <span className="required">*</span>Year
                                    </label>
                                    {errors.year && <div className="error-message">{errors.year}</div>}
                                </div>
                            </div>
                            <div className="payroll-process-container-part">
                                <div className={`payroll-process-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                    <Select
                                        name="month"
                                        options={monthOptions}
                                        value={monthOptions.find(opt => opt.value === month) || null}
                                        onChange={option => handleInputChange(option, 'month')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        <span className="required">*</span>Month
                                    </label>
                                    {errors.month && <div className="error-message">{errors.month}</div>}
                                </div>
                            </div>
                        </div>
                        {/* <div className="payroll-process-maincontainer">

                            <div className="payroll-process-container-part">
                                <div className={`payroll-process-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                    <Select
                                        name="project"
                                        options={projectResponse}
                                        value={projectResponse.find(opt => opt.value === project) || null}
                                        onChange={option => handleInputChange(option, 'project')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        Project
                                    </label>
                                    {errors.project && <div className="error-message">{errors.project}</div>}
                                </div>
                            </div>
                            <div className="payroll-process-container-part">

                            </div>
                        </div> */}
                        <div className="payroll-process-btn-div">
                            <button
                                type="submit"
                                className="payroll-process-btn"
                                disabled={!isFetchDataEnabled}
                            >
                                Fetch Data
                            </button>
                        </div>
                    </form>


                </div>

            </div>

            {errors.general && (
                <div className="error-message" style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                    {errors.general}
                </div>
            )}
            <div className="payroll-process-table-container">

                <table className="payroll-process-table">
                    <thead>
                        <tr className='span-headers'>
                            <th colSpan="9"></th>
                            <th colSpan="5" style={{ backgroundColor: "rgb(163 232 251)" }}>GROSS SALARY</th>
                            <th colSpan="2" style={{ backgroundColor: "#a1f696" }}>ATTENDANCE</th>
                            <th colSpan="5" style={{ backgroundColor: "#ef89f8ff" }}>EARNINGS</th>
                            <th colSpan="3" style={{ backgroundColor: "#f6ec96ff" }}>DEDUCTIONS</th>
                            <th style={{ backgroundColor: "#a1f696", whiteSpace: "nowrap" }}>Net Salary</th>
                            <th colSpan="2" style={{ backgroundColor: "#ef89f8ff" }}>EMPLOYER CONT</th>
                            <th colSpan="3"></th>
                            <th colSpan="3"></th>
                            <th colSpan="2"></th>
                        </tr>
                        <tr>

                            <th>S.No.</th>
                            <th>Employee ID</th>
                            <th>Name of the Employee</th>
                            <th>District Name</th>
                            <th>Designation</th>
                            <th>UAN</th>
                            <th>Member ID</th>
                            <th>ESIC No.</th>
                            <th>Name</th>
                            <th>Basic & DA</th>
                            <th>HRA</th>
                            <th>Conveyance</th>
                            <th>Other Allowances</th>
                            <th>Total Gross Salary</th>
                            <th>No of Days </th>
                            <th>Present Days</th>
                            <th>Basic</th>
                            <th>HRA</th>
                            <th>Conveyance</th>
                            <th>Other Allowances</th>
                            <th>Total Gross Salary</th>
                            <th>PT</th>
                            <th>PF Employee</th>
                            <th>ESI Employee</th>
                            <th>Net Salary</th>
                            <th>Employer PF</th>
                            <th>Employer ESI</th>
                            <th>SBI Account Number</th>
                            <th>IFSC Code</th>
                            <th>SBI Branch</th>
                            <th>CTC</th>
                            <th>Total PF</th>
                            <th>Total ESI</th>
                            <th>EPF Wages</th>
                            <th>ESI Wages</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attendanceData.map((emp, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{emp.employeeId}</td>
                                <td>{emp.fullName}</td> {/* fullName instead of employeeName */}
                                <td>{emp.districtName}</td>
                                <td>{emp.designation}</td>
                                <td>{emp.uanNumber}</td> {/* PF UAN Member ID */}
                                <td>{emp.memberId}</td>
                                <td>{emp.esiNumber}</td> {/* Insurance No. */}
                                <td>{emp.fullName}</td> {/* Name */}
                                <td>{emp.defaultBasicSalary}</td> {/* Basic & DA */}
                                <td>{emp.defaultHra}</td>
                                <td>{emp.defaultConveyance}</td>
                                <td>{emp.defaultMedicalAllowance + emp.defaultOtherAllowance}</td> {/* Other Allowances */}
                                <td>{emp.defaultGrossSalary}</td> {/* Total Gross Salary */}
                                <td>{emp.totalDaysInMonth}</td> {/* No of Days */}
                                <td>{emp.presentDays}</td>
                                <td>{emp.calculatedBasicSalary}</td>
                                <td>{emp.calculatedHra}</td>
                                <td>{emp.calculatedConveyance}</td>
                                <td>{emp.calculatedMedicalAllowance + emp.calculatedOtherAllowance}</td>
                                <td>{emp.calculatedGrossSalary}</td>
                                <td>{emp.calculatedPt}</td>
                                <td>{emp.calculatedEpf}</td>
                                <td>{emp.calculatedEsi}</td>
                                <td>{emp.calculatedNetSalary}</td>
                                <td>{emp.calculatedEmployerEpf}</td>
                                <td>{emp.calculatedEmployerEsi}</td>
                                <td>{emp.accountNumber || "-"}</td>
                                <td>{emp.ifscCode || "-"}</td>
                                <td>{emp.branchName || "-"}</td>
                                <td>{emp.calculatedCtcAsPerBreakup}</td>
                                <td>{(emp.calculatedEpf) + (emp.calculatedEmployerEpf)}</td> {/* Total PF */}
                                <td>{(emp.calculatedEsi) + (emp.calculatedEmployerEsi)}</td> {/* Total ESI */}
                                <td>{emp.epfWages}</td> {/* EPF Wages */}
                                <td>{emp.esiWages}</td> {/* ESI Wages */}
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>

            {hasFetched && attendanceData.length === 0 && (
                <div className="no-data-message">
                    Payroll for the selected month has already been generated. Refer to the Reports section.
                </div>
            )}
        </>
    );
};

export default EmployeePayrollProcess;